var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavingHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    xlinkHref: "data:image/png;base64",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#724F3D;}\r\n\t.st1{fill:#A86C4D;}\r\n\t.st2{fill:none;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:#FF87AF;}\r\n\t.st4{fill:#FF6196;}\r\n\t.st5{fill:#FFE500;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st6{fill:#45413C;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st7{fill:#FF6242;}\r\n\t.st8{fill:#FFA694;}\r\n\t.st9{fill:#FFAA54;}\r\n\t.st10{fill:#00B8F0;}\r\n\t.st11{fill:#009FD9;}\r\n\t.st12{fill:#FFE500;}\r\n\t.st13{fill:#EBCB00;}\r\n\t.st14{fill:#9CEB60;}\r\n\t.st15{fill:#6DD627;}\r\n\t.st16{fill:#724F3D;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st17{fill:#BF8DF2;}\r\n\t.st18{fill:#9F5AE5;}\r\n\t.st19{fill:#00DFEB;}\r\n\t.st20{fill:#00C9D4;}\r\n\t.st21{fill:#FF866E;}\r\n\t.st22{fill:#00F5BC;}\r\n\t.st23{fill:#00DBA8;}\r\n\t.st24{fill:#FF8A14;}\r\n\t.st25{fill:#DE926A;}\r\n\t.st26{fill:#FFCEBF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st27{fill:#FFB59E;}\r\n\t.st28{fill:#FFCEBF;}\r\n\t.st29{fill:#A86C4D;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st30{fill:#ADC4D9;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st31{fill:#FFF48C;}\r\n\t.st32{fill:#C0DCEB;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st33{fill:#4ACFFF;}\r\n\t.st34{fill:#45413C;}\r\n\t.st35{fill:#FFDCD1;}\r\n\t.st36{opacity:0.15;fill:#45413C;}\r\n\t.st37{fill:#FFB59E;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st38{fill:#00DFEB;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st39{fill:#F0F0F0;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st40{fill:#E0366F;}\r\n\t.st41{fill:#FFE8E0;}\r\n\t.st42{fill:#EBCB00;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st43{fill:#FFDA8F;}\r\n\t.st44{fill:#FFBE3D;}\r\n\t.st45{fill:#FFE9BD;}\r\n\t.st46{fill:#FFFFFF;}\r\n\t.st47{fill:#E0E0E0;}\r\n\t.st48{fill:#656769;}\r\n\t.st49{fill:#525252;}\r\n\t.st50{fill:#87898C;}\r\n\t.st51{fill:#656769;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st52{fill:#B89558;}\r\n\t.st53{fill:#947746;}\r\n\t.st54{fill:#525252;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st55{fill:#FFFFFF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st56{fill:#A6FBFF;stroke:#45413C;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_10519_",
    className: "st36",
    cx: 24,
    cy: 45.5,
    rx: 12.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10518_",
    className: "st12",
    d: "M33.5,19.3l-0.1,3.3L22.1,11.3c-0.9-0.9-2.4-1.1-3.4-0.3c-1.2,1-1.2,2.7-0.2,3.7l-1.6-1.6   c-1-1-2.7-1.2-3.8-0.2c-1.1,1-1.2,2.8-0.1,3.9l-0.1-0.1c-0.8-0.8-2.1-1-3-0.5c-1.5,0.9-1.7,2.8-0.5,3.9l3,3   c-0.9-0.9-2.4-0.9-3.2,0.2c-0.7,0.9-0.6,2.2,0.2,3L22,39c3.7,3.7,9.7,3.7,13.4-0.1c2.8-2.9,4.3-6.8,4-10.8L39,16c0-0.6-0.5-1-1.1-1   h0C35.5,15,33.6,16.9,33.5,19.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_10515_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10517_",
    className: "st31",
    d: "M33.3,22.5L22.1,11.3c-0.9-0.9-2.4-1.1-3.4-0.3c-1.1,0.9-1.2,2.4-0.4,3.5    c0.1-0.1,0.2-0.3,0.4-0.4c1-0.8,2.5-0.6,3.4,0.3l9.7,9.7L33.3,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10516_",
    className: "st31",
    d: "M39.1,19.1L39,16c0-0.6-0.5-1-1.1-1c-2.4,0-4.4,1.9-4.4,4.3l-0.1,3.3l0.1-0.1    c0.1-2.4,2.1-4.3,4.4-4.3C38.5,18.1,39.1,18.5,39.1,19.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10514_",
    className: "st2",
    d: "M33.5,19.3l-0.1,3.3L22.1,11.3c-0.9-0.9-2.4-1.1-3.4-0.3c-1.2,1-1.2,2.7-0.2,3.7l-1.6-1.6   c-1-1-2.7-1.2-3.8-0.2c-1.1,1-1.2,2.8-0.1,3.9l-0.1-0.1c-0.8-0.8-2.1-1-3-0.5c-1.5,0.9-1.7,2.8-0.5,3.9l3,3   c-0.9-0.9-2.4-0.9-3.2,0.2c-0.7,0.9-0.6,2.2,0.2,3L22,39c3.7,3.7,9.7,3.7,13.4-0.1c2.8-2.9,4.3-6.8,4-10.8L39,16c0-0.6-0.5-1-1.1-1   h0C35.5,15,33.6,16.9,33.5,19.3z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10513_",
    className: "st2",
    y1: 23.2,
    x1: 12.5,
    x2: 18.6,
    y2: 28.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10512_",
    className: "st2",
    x1: 13,
    y1: 16.8,
    x2: 21.9,
    y2: 25.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_10511_",
    className: "st2",
    x1: 18.5,
    y1: 14.7,
    x2: 25.7,
    y2: 21.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10510_",
    className: "st2",
    d: "M33.4,22.6l-3.6,3.6c-2.3,2.3-2.3,6.1,0,8.5l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10509_",
    className: "st2",
    d: "M24.1,8.8c0,0,2.2,0.2,4.3,2c1.9,1.6,2.7,4,2.7,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10508_",
    className: "st2",
    d: "M24.7,6.1c0,0,2.8,0.3,5.3,2.4c2.4,2,3.3,4.9,3.3,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10507_",
    className: "st2",
    d: "M4.6,24.2c0,0-0.3,2.2,0.8,4.7c1.1,2.3,3.2,3.6,3.2,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10506_",
    className: "st2",
    d: "M1.9,24.1c0,0-0.4,2.8,1,5.8c1.3,2.8,3.9,4.5,3.9,4.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/waving-hand.3b527fe583f09542c4cd95559a380bc6.svg";
export { ForwardRef as ReactComponent };